/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum LoginAttemptResponseDtoOutcome {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  LOCKED = "LOCKED",
  UNLOCKED = "UNLOCKED",
  PIN_RESET = "PIN_RESET",
  PASSWORD_RESET = "PASSWORD_RESET",
  ACCOUNT_DEACTIVATED = "ACCOUNT_DEACTIVATED",
  ACCOUNT_REACTIVATED = "ACCOUNT_REACTIVATED",
}
